

















































import { GetExtendPageInfoRes } from '@/api/api-type'
import { useRouter } from '@/router/helper'
import { omega } from '@didi/driver-biz-sdk'
import { defineComponent, PropType, computed, watch, ref } from '@vue/composition-api'
import NumScroll from './num-scroll.vue'

export default defineComponent({
  components: {
    NumScroll
  },
  props: {
    cardData: {
      type: Object as PropType<GetExtendPageInfoRes['card_data']>,
      default: () => {
        return {}
      }
    },
    totalMoney: {
      type: Number,
      default: 0
    },
    thisTimeMoney: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const visible = computed(() => {
      const cardData = props.cardData
      return cardData.wait_effective_num ||
        cardData.effective_num ||
        cardData.all_quilt_flag ||
        cardData.all_expire ||
        cardData.part_expire_quit
    })
    const scrollTotalMoney = ref(0)
    const scrollThisTimeMoney = ref(0)
    watch(() => props.totalMoney, (newV) => {
      scrollTotalMoney.value = new Array((newV + '').length).fill(0).join('') as unknown as number
      setTimeout(() => {
        scrollTotalMoney.value = newV
      }, 1000)
    }, { immediate: true })

    watch(() => props.thisTimeMoney, (newV) => {
      scrollThisTimeMoney.value = new Array((newV + '').length).fill(0).join('') as unknown as number
      setTimeout(() => {
        scrollThisTimeMoney.value = newV
      }, 1000)
    }, { immediate: true })

    const router = useRouter()
    function clickBtn() {
      omega.trackEvent('am_c_insure_medical_landpage_mypolicy_ck')
      router.push({
        path: '/policy-list'
      })
    }
    const isExpire = computed(() => {
      return props.cardData.all_expire || props.cardData.part_expire_quit === 1
    })
    const isQuilt = computed(() => {
      return props.cardData.all_quilt_flag || props.cardData.part_expire_quit === 2
    })
    const exitTitle = computed(() => {
      if (isExpire.value) {
        return '您当前没有生效中的保障'
      } else if (isExpire.value) {
        return '您的保单已过生效周期'
      }
      return ''
    })
    const exitContent = computed(() => {
      const info = props.cardData
      if (isExpire.value) {
        return '师傅您好，您的保单已过保障生效周期，当前无生效中保单'
      } else if (isQuilt.value) {
        return `师傅您好，您已于${info.all_quilt_time}在保司侧办理退保，退保后12个月可再次享受平台补贴。如您需要加入，可在下方平台补贴及自费专区查看优质保障。`
      }
      return ''
    })
    return {
      visible,
      scrollTotalMoney,
      scrollThisTimeMoney,
      clickBtn,
      exitTitle,
      exitContent
    }
  }
})
